import { createBrowserRouter, RouteObject, To } from "react-router-dom";
import GamesPage from "../features/games/pages/GamesPage";
import LandingPage from "../features/landing/pages/LandingPage";
import RankingPage from "../features/ranking/pages/RankingPage";
import i18n from "../i18n";
import Page404 from "../uikit/Pages/Page404";
import FieldsPage from "../features/fields/pages/FieldsPage";
import StatsPage from "../features/stats/pages/StatsPage";
import TeamProfileListing from "../features/teams/pages/TeamProfileListing";
import TeamsPage from "../features/teams/pages/TeamsPage";

export const getRoutes = (): (RouteObject & { path: To; title: string })[] => [
  {
    id: "landing",
    path: "/",
    element: <LandingPage />,
    title: i18n.t("navigation:landing:title"),
  },
  {
    id: "teams",
    path: "/teams",
    element: <TeamsPage />,
    title: i18n.t("navigation:teams:title"),
  },
  {
    id: "team",
    path: "/teams/:id",
    element: <TeamProfileListing />,
    title: i18n.t("navigation:team:title"),
  },
  {
    id: "ranking",
    path: "/ranking",
    element: <RankingPage />,
    title: i18n.t("navigation:ranking:title"),
  },
  {
    id: "games",
    path: "/games",
    element: <GamesPage />,
    title: i18n.t("navigation:games:title"),
  },
  {
    id: "stats",
    path: "/stats",
    element: <StatsPage />,
    title: i18n.t("navigation:stats:title"),
  },
  {
    id: "fields",
    path: "/fields",
    element: <FieldsPage />,
    title: i18n.t("navigation:fields:title"),
  },
  {
    id: "404",
    path: "*",
    element: <Page404 />,
    title: i18n.t("navigation:404:title"),
  },
];

export const NAVIGATION_BLACKLIST = ["payment-status", "404", "team"];
export const NOT_READY_NAVIGATION_BLACKLIST = [
  "teams",
  "ranking",
  "games",
  "stats",
  "fields",
  "404",
];

export const getNavigationRoutes = (
  isTournamentReady: boolean,
  pages: ("teams" | "rankings" | "games" | "fields" | "stats")[] = [
    "teams",
    "rankings",
    "games",
    "fields",
    "stats",
  ]
) => {
  let routes = getRoutes();
  if (!pages.includes("stats")) {
    routes = routes.filter((route) => route.id && route.id !== "stats");
  }
  if (!pages.includes("fields")) {
    routes = routes.filter((route) => route.id && route.id !== "fields");
  }
  if (!pages.includes("games")) {
    routes = routes.filter((route) => route.id && route.id !== "games");
  }
  if (!pages.includes("teams")) {
    routes = routes.filter((route) => route.id && route.id !== "teams");
  }
  if (!pages.includes("rankings")) {
    routes = routes.filter((route) => route.id && route.id !== "rankings");
  }
  if (isTournamentReady) {
    return routes.filter(
      (route) => route.id && !NAVIGATION_BLACKLIST.includes(route.id)
    );
  }
  return routes.filter(
    (route) =>
      route.id &&
      !NOT_READY_NAVIGATION_BLACKLIST.includes(route.id) &&
      !NAVIGATION_BLACKLIST.includes(route.id)
  );
};

export default createBrowserRouter(getRoutes());
